import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=1e4c60de&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4c60de')) {
      api.createRecord('1e4c60de', component.options)
    } else {
      api.reload('1e4c60de', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=1e4c60de&", function () {
      api.rerender('1e4c60de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y614QLCoIRte/JS/comp/ErrorMessage.vue"
export default component.exports